// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import {combineReducers} from 'redux';
import {ActionTypes} from 'utils/constants.jsx';

function filters(state = {}, action) {
    const nextState = {...state};

    switch (action.type) {
        case 'MEETING_HISTORY_FILTER': {
            return action.data;
        }
        default:
          return state;
    }
}

function meetingState(state={}, action) {
    switch (action.type) {
    case ActionTypes.UPDATE_MEETING_STATE:
        return action.data;
    default:
        return state;
    }
}

function meetingJoinState(state={state: 0, meetingId: ""}, action) {
    switch (action.type) {
    case ActionTypes.UPDATE_MEETING_JOIN_STATE:
        return action.data;
    default:
        return state;
    }
}

function guestMeetingStarted(state={mode: 0, room_id: ""}, action) {
    switch (action.type) {
    case ActionTypes.UPDATE_GUEST_MEETING_STARTED:
        return action.data;
    default:
        return state;
    }
}

export default combineReducers({
    filters,meetingState,meetingJoinState,guestMeetingStarted
});
